export const SET_CURRENCIES = 'SET_CURRENCIES';
export const SET_CURRENCY = 'SET_CURRENCY';
export const ADD_CURRENCY = 'ADD_CURRENCY';
export const UPDATE_CURRENCY = 'UPDATE_CURRENCY';
export const REMOVE_CURRENCY = 'REMOVE_CURRENCY';
export const CLEAR_CURRENCY = 'CLEAR_CURRENCY';
export const CLEAR_CURRENCIES = 'CLEAR_CURRENCIES';
